module.exports = __webpack_public_path__ + "img/vista-rua-com-predios@large.jpg";